import { NavLink, useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"

const Topnavbar = ({ titulo }) => {

    const [busqueda, setBusqueda] = useState("")

    useEffect(() => {
    }, [busqueda])

    const red_asistencial = (localStorage.getItem("red_asistencial")) ? localStorage.getItem("red_asistencial") : "NN"

    let history = useNavigate()

    const handleSearch = () => {
        history(`/inventario?bus=${busqueda}`)
        setBusqueda("")
    }

    return (
        <nav className="main-header navbar navbar-expand navbar-cyan navbar-dark border-bottom-0">
            <ul className="navbar-nav">
                <li className="nav-item">
                    <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars"></i></a>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <NavLink to="/dashboard" className="nav-link">
                        <p>Dashboard</p>
                    </NavLink>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <NavLink to="/inventario" className="nav-link">
                        <p>Inventario</p>
                    </NavLink>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <NavLink to="/catalogosap" className="nav-link">
                        <p>SAP</p>
                    </NavLink>
                </li>
                {
                    /*<li className="nav-item d-none d-sm-inline-block">
                        <NavLink to="/almacen" className="nav-link">
                            <p>Almacén</p>
                        </NavLink>
                    </li>
                    */
                }
            </ul>
            <form className="form-inline ml-2" onSubmit={e => { e.preventDefault(); handleSearch() }} name="buscador_top">
                <div className="form-inline">
                    <div className="input-group">
                        <input className="form-control form-control" type="search" placeholder="Búsqueda rápida" aria-label="Búsqueda rápid" value={busqueda} onChange={e => { setBusqueda(e.target.value) }} name="buscador_top" />
                        <div className="input-group-append">
                            <button className="btn btn-sidebar border">
                                <i className="fas fa-search fa-fw">
                                </i>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            {/* Agregamos un boton de login/logout al final del navbar */}
            <ul className="navbar-nav ml-auto">
                <li className="nav-item small text-center">
                    <span>{red_asistencial}</span>
                </li>
            </ul>
        </nav>
    )
}

export default Topnavbar